import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDocumentSearch(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="M19.495 12.501V5.746a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v12.501a3 3 0 0 0 3 3h5.245m-4.25-6.496h1.5m-1.5-8h7.5m-7.5 4h3.5m8.121 9.614a3 3 0 1 1-4.242-4.243 3 3 0 0 1 4.242 4.243Zm0 0 1.88 1.879"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentSearch);
export default ForwardRef;
